@if (!embedded()) {
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-back-button
          mode="md"
          defaultHref="settings"
        ></ion-back-button>
      </ion-buttons>
      <ion-title
        role="heading"
        aria-level="1"
        mode="md"
      >
        {{ 'page.settings.preferences' | translate }}
      </ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <div class="app__content preferences">
      <div class="app__description">
        <p>{{ 'page.settings.preferences.desc' | translate }}</p>
      </div>
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  </ion-content>
} @else {
  <ng-container *ngTemplateOutlet="content"></ng-container>
}
<ng-template #content>
  <div [formGroup]="preferencesForm">
    @if (!isProjectApp) {
      <app-settings-control
        [type]="'suggestions'"
        [control]="suggestionsControl"
      ></app-settings-control>
    }
    <app-settings-control
      [type]="'distance-unit'"
      [control]="distanceTypeControl"
      [options]="distanceOptions()"
    ></app-settings-control>
    @if (isDarkModeEnabled) {
      <app-settings-control
        [type]="'appearance'"
        [control]="appearanceControl"
        [options]="appearanceOptions()"
      ></app-settings-control>
    }
    <app-settings-control
      [type]="'contrast'"
      [control]="contrastControl"
      [options]="contrastOptions()"
    ></app-settings-control>
  </div>
</ng-template>
